type PlayerResult = {
	position: number;
	score: number;
};

type SortedPlayer = {
	playerId: string;
	score: number;
	position: number;
};

function sortPlayers(playerResults: Record<string, PlayerResult>): SortedPlayer[] {
	return Object.entries(playerResults)
		.map(([playerId, { position, score }]) => ({ playerId, score, position }))
		.sort((a, b) => a.position - b.position);
}

export { sortPlayers };
export default sortPlayers;
